<template>
  <a :href="link">
    <img
      v-if="hasValidSrc"
      :src="src"
      :width="width"
      :height="height"
      class="thumbnail">
    <span
      v-else
      class="thumbnail thumbnail--placeholder">
      <icon-font
        name="shop"
        class="thumbnail__icon"
      />
    </span>
  </a>
</template>

<script>
import IconFont from '@/mikan/_shared/components/atoms/icons/IconFont.vue';

export default {
  components: {
    IconFont,
  },
  props: {
    src: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 30,
    },
    height: {
      type: Number,
      default: 30,
    },
  },
  computed: {
    hasValidSrc() {
      return this.src !== '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/_shared/base/constants';
@import '~@/mikan/_shared/base/mixins';

.thumbnail {
  border-radius: 999em;

  &--placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $color-orange;
    font-size: 22px;
    @include for-tb-pc {
      padding: 4px;
    }
    @include for-sp {
      padding: 9px;
      border: 1px solid $color-white;
    }
  }

  &__icon {
    color: $color-white;
  }
}
</style>
